import { useMemo } from "react"
import { createEvent } from "library/local-events/index.mjs"
import { debounce } from "lib/debounce"
import { useRefresh } from "lib/@hooks/useRefresh"
import { AcceptAllButton } from "routes/schedule/plugins/legislation-resolutions/accept-all-button"
import { getCopResolution } from "./controller/get-cop-resolution.controller"
import { saveCopResolutionDecisions } from "./controller/save-cop-resolution-decisions.controller"

export const CopDecisionsChanged = createEvent("CopDecisionsChanged")

export function CopToolbarAcceptAll({ id }) {
    const resolution = getCopResolution.useResults({ id })
    const changes = resolution?.proposedChanges ?? []
    const refresh = useRefresh()
    const debouncedSave = useMemo(() => debounce((params) => saveCopResolutionDecisions(params), 500), [])

    if (!resolution || changes.length === 0) return null

    return <AcceptAllButton changes={changes} onAcceptAll={handleAcceptAll} />

    function handleAcceptAll(decision) {
        for (const c of changes) {
            c.decision = decision
        }
        refresh()
        CopDecisionsChanged.raise(decision)
        const decisions = changes.map((c) => ({ changeId: c.id, decision }))
        debouncedSave({ id, decisions })
    }
}
